<template>
  <narrow-container>
    <embedded-spinner :show="inProgress" />
    <div v-show="!inProgress">
      <activate-auto-topup
        v-if="autoTopupActivationPossible"
        :tariff-size-name="autoTopupStatus.tariffSizeName"
        :tariff-price="autoTopupStatus.price"
        :duration="autoTopupStatus.duration"
        :data-tariff="autoTopupStatus.dataTariff"
        :email-blank="autoTopupStatus.emailBlank"
        :email-required="autoTopupStatus.emailRequired"
      />
      <auto-topup-in-progress v-if="autoTopupActivationInProgress" />
      <deactivate-auto-topup
        v-if="autoTopupDeactivationPossible"
        :tariff-size-name="autoTopupStatus.tariffSizeName"
        :tariff-price="autoTopupStatus.price"
        :duration="autoTopupStatus.duration"
      />
    </div>
  </narrow-container>
</template>

<script>
  const AUTO_TOPUP_STATUS_NOT_ACTIVE = 1;
  const AUTO_TOPUP_STATUS_NOT_POSSIBLE = 0;
  const AUTO_TOPUP_STATUS_ACTIVE_SEPA = 2;
  const AUTO_TOPUP_STATUS_ACTIVE_CREDIT_CARD = 3;

  import ActivateAutoTopup from "@/views/autotopup/ActivateAutoTopup";
  import AutoTopupInProgress from "@/views/autotopup/AutoTopupInProgress";
  import DeactivateAutoTopup from "@/views/autotopup/DeactivateAutoTopup";

  export default {
    name: "AutoTopUp",
    components: {
      DeactivateAutoTopup,
      AutoTopupInProgress, ActivateAutoTopup},
    computed: {
      autoTopupStatus: function() {
        return this.$store.getters['autotopup/status'];
      },
      inProgress: function() {
        return this.$store.getters['autotopup/inProgress'];
      },
      autoTopupActivationPossible: function() {
        return this.autoTopupStatus && this.autoTopupStatus.status == AUTO_TOPUP_STATUS_NOT_ACTIVE;
      },
      autoTopupActivationInProgress: function() {
        return this.autoTopupStatus && this.autoTopupStatus.status == AUTO_TOPUP_STATUS_NOT_POSSIBLE;
      },
      autoTopupDeactivationPossible: function() {
        return this.autoTopupStatus &&
          (this.autoTopupStatus.status == AUTO_TOPUP_STATUS_ACTIVE_SEPA
            || this.autoTopupStatus.status == AUTO_TOPUP_STATUS_ACTIVE_CREDIT_CARD)
      }


    },
    mounted: function(){
      this.$store.dispatch("autotopup/refreshAutoTopUpStatus", this.$http);
    },

  }
</script>

<style scoped>
</style>
